import Nav from "@/components/Nav";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="bg-ivory">
      <Nav />
      <div className="pt-16">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}
